import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserShortInfo } from "../../types";
import ManShortSelector from "../../components/ui/shortItemSelect";
import {
  libBackend,
  backend,
  taskBackend,
  TaskCreationData,
  InviteLinkCreationData,
  Role,
  GroupListData,
} from "../../services";
import { actions, RootState } from "../../state/reducer";
import { toast } from "sonner";
import DateInput from "../../components/ui/dateInput";
import { generateRandomString } from "../../utils";

interface ModalLoaderProps {
  user_id: number;
  onSave: () => void;
  closeModal: () => void;
}

const TransferActivityModal: React.FC<ModalLoaderProps> = ({
  user_id,
  onSave,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const State = useSelector((state: RootState) => state);
  const groups = State.groupsToSelect;
  const rights = State.rights;
  const [usersToSelect, setUsersToSelect] = useState<UserShortInfo[]>([]);
  const [selectedGroup, setSelectedGroup] = useState<number>(
    rights.group_ids[0]
  );
  const [selectedUserId, setSelectedUser] = useState<number>();
  useEffect(() => {}, [groups]);

  const saveAction = async () => {
    return new Promise((resolve) => {
      if (!selectedUserId) {
        toast("Выберите пользователя!");
        return;
      }
      backend
        .transferUserActivity(user_id, selectedUserId)
        .then((res) => {
          toast(res.success ? "Изменения сохранены" : "Ошибка сохранения");
          dispatch(actions.selectItem(generateRandomString(3)));
          resolve(true);
        })
        .catch(() => {
          toast("Ошибка сохранения");
          resolve(false);
        });
    });
  };

  const closeWithSave = async () => {
    await saveAction();
    onSave(); // Передаем новое фото в callback
    closeModal(); // Закрываем модальное окно
  };

  return (
    <div className="creationForm">
      <div className="modalHeading">
        <h3>Передача клиентов и задач другому пользователю</h3>
      </div>
      <form className="columnCenter">
        {/* Поле: Название задачи */}
        <div className="flex formRow">
          <div className="fieldName">Группа</div>
          <div className="fieldInput flex">
            <select
              id="group_id"
              name="group_id"
              value={selectedGroup}
              onChange={(event) => {
                const group = Number(event.target.value);
                backend.getAllUsersShorts({ group_id: group }).then((res) => {
                  setUsersToSelect(res.users);
                });
                setSelectedGroup(group);
              }}
            >
              {rights.rang < 3 && <option value="0">Любая</option>}
              {groups.map((item, index) => {
                return (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        {/* Поле: Ответственный */}
        <div className="formField formRow">
          <label>Новый пользователь:</label>
          <ManShortSelector
            items={usersToSelect}
            onChangeCallback={(id) => setSelectedUser(id)}
          />
        </div>
        {/* Кнопки действий */}
        <div className="flex between btnRow">
          <button
            className="filterButton"
            type="button"
            onClick={closeWithSave}
          >
            Сохранить
          </button>
          <button className="cancelButton" type="button" onClick={closeModal}>
            Отменить
          </button>
        </div>
      </form>
    </div>
  );
};

export default TransferActivityModal;
